import React from "react";
import classNames from "classnames";
import styles from "./bless-btn.module.scss";

type Props = {
  buttonType?: "outlined" | "rainbow" | "solid";
  color?: "lavender" | "greenYellow" | "dodgerBlue" | "white" | "grey";
  children: React.ReactNode;
  styles?: React.CSSProperties;
  size?: "large" | "medium" | "small";
  onClick?: (val?: any) => void;
  disabled?: boolean;
};

const BlessButton = (props: Props) => {
  const {
    buttonType = "solid",
    color = "greenYellow",
    children,
    styles: stylesheet,
    size = "large",
    onClick,
    disabled = false,
  } = props;

  const btnColor = color === "white" ? "white" : "";

  const activeButtonType = () => {
    switch (buttonType) {
      case "outlined":
        return styles.outlined;
      case "rainbow":
        return styles.rainbow;
      case "solid":
        return styles.solid;
    }
  };

  const activeSize = () => {
    switch (size) {
      case "large":
        return;
      case "medium":
        return styles.medium;
      case "small":
        return styles.small;
    }
  };

  return (
    <button
      disabled={disabled}
      className={classNames(
        styles.blessButton,
        activeButtonType(),
        activeSize(),
        disabled && styles.disabled
      )}
      style={{ color: btnColor, borderColor: btnColor, ...stylesheet }}
      onClick={onClick}>
      {children}
    </button>
  );
};

export default BlessButton;
